import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

// page imports
import MainPage from '@/components/MainPage'
import HouseholdPage from '@/components/HouseholdPage'
import ContactDetails from '@/components/ContactDetailsPage'
import HouseholdDetails from '@/components/HouseholdDetailsPage'
import IndividualDetails from '@/components/IndividualDetailsPage'
import LocationDetails from '@/components/LocationDetailsPage'
import HouseholdExceptions from '@/components/HouseholdExceptionsPage'
import HouseholdStatus from '@/components/HouseholdStatusPage'
import HouseholdNotes from '@/components/HouseholdNotesPage'
import HouseholdVisits from '@/components/HouseholdVisitsPage'
import AddHouseholdException from '@/components/AddHouseholdExceptionPage'
import AddIndividualException from '@/components/AddIndividualExceptionPage'
import AddNote from '@/components/AddNotePage'
import BeneficiaryList from '@/components/BeneficiaryListPage'

// auth pages
import LoginPage from '@/components/LoginPage'
import TempPWChange from '@/components/TempPWChange'
import LoginOTP from '@/components/LoginOTPPage'
import PasswordRecovery from '@/components/PasswordRecoveryPage'
import UserList from '@/components/UserListPage'
import AddHQUser from '@/components/AddHQUserPage'
import AddFieldUser from '@/components/AddFieldUserPage'
import ChangePassword from '@/components/ChangePasswordPage'

// utility pages
import ErrorNotification from '@/components/ErrorNotificationPage'
import Test from '@/components/TestPage'


// store
import { store } from '../_store'

Vue.use(Router)
Vue.use(BootstrapVue)

export const router = new Router({
  routes: [
    {
      path: '/errornotification/:message',
      name: 'ErrorNotification',
      component: ErrorNotification
    },
    {
      path: '/',
      name: 'Main',
      component: MainPage
    },
    {
      path: '/household/:hhid',
      name: 'Household',
      component: HouseholdPage
    },
    {
      path: '/contactdetails/:hhid',
      name: 'ContactDetails',
      component: ContactDetails
    },
    {
      path: '/householddetails/:hhid',
      name: 'HouseholdDetails',
      component: HouseholdDetails
    },
    {
      path: '/individualdetails/:hhid/:pid',
      name: 'IndividualDetails',
      component: IndividualDetails
    },
    {
      path: '/locationdetails/:hhid',
      name: 'LocationDetails',
      component: LocationDetails
    },
    {
      path: '/exceptions/:hhid',
      name: 'HouseholdExceptions',
      component: HouseholdExceptions
    },
    {
      path: '/addhouseholdexception/:hhid',
      name: 'AddHouseholdException',
      component: AddHouseholdException
    },
    {
      path: '/addindividualexception/:hhid',
      name: 'AddIndividualException',
      component: AddIndividualException
    },
    {
      path: '/householdstatus/:hhid',
      name: 'HouseholdStatus',
      component: HouseholdStatus
    },
    {
      path: '/householdnotes/:hhid',
      name: 'HouseholdNotes',
      component: HouseholdNotes
    },
    {
      path: '/addnote/:hhid',
      name: 'AddNote',
      component: AddNote
    },
    {
      path: '/householdvisits/:hhid',
      name: 'HouseholdVisits',
      component: HouseholdVisits
    },
    {
      path: '/beneficiarylist',
      name: 'BeneficiaryList',
      component: BeneficiaryList
    },
    // auth pages
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/temppwchange',
      name: 'TempPWChange',
      component: TempPWChange
    },
    {
      path: '/loginotp',
      name: 'LoginOTP',
      component: LoginOTP
    },
    {
      path: '/passwordrecovery',
      name: 'PasswordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/userlist',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/addhquser',
      name: 'AddHQUser',
      component: AddHQUser
    },
    {
      path: '/addfielduser',
      name: 'AddFieldUser',
      component: AddFieldUser
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    // test
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    // catch all
    {
      path: '*',
      redirect: {
        path: `/errornotification/ERR_UNKNOWN_PATH`
      }
    }
  ]
})

// only allow navigation to non-public pages to authenticated users
router.beforeEach((to, from, next) => {
  // specify public pages, only login page for now
  const publicPages = ['/login', '/passwordrecovery']
  const authRequired = !publicPages.includes(to.path)
  // get authenticated state from vuex auth store
  const loggedIn = store.state.auth.authenticated

  console.log({loggedIn, authRequired})

  if (authRequired && !loggedIn) {
    console.log("user not logged in, redirect to login page")
    return next('/login')
  }

  next()
})


// WEBPACK FOOTER //
// ./src/router/index.js